export default "__VITE_ASSET__BIyGR3xX__"